export default "__VITE_ASSET__Dotrnzax__"